import { createSelector } from 'reselect'
const selectPositions = store => store.map.positions || []

const selectGeoDataPositions = store => store.map.geoDataPositions || []

const selectWoltDriverDeliveries = store => store.map.woltDriverDeliveries || []

export const selectWoltDriversPositions = createSelector(
	selectWoltDriverDeliveries,
	(woltDriverDeliveries) => {
		return woltDriverDeliveries.map(delivery => ({ ...delivery?.courierLocation, partnerDriverType: 'WOLT_DRIVE' }))
	}
)

export const selectDriversPositions = createSelector(
	selectPositions,
	selectGeoDataPositions,
	selectWoltDriversPositions,
	(registrationPositions, geoDataPositions, woltDriversPositions) => {
		const positionsByUsername = new Map()
		registrationPositions.forEach(position => positionsByUsername.set(position.username, position))
		geoDataPositions.forEach(position => positionsByUsername.set(position.username, position))
		return [...positionsByUsername.values(), ...woltDriversPositions]
	}
)
